import classNames from "classnames";
import React from "react";
import { useParams } from "react-router-dom";

import { useWorkspaceContracts } from "@/api/queries/contracts";
import LoadingWrapper from "@/components/loading-wrapper";
import ListTitleSettings from "@/components/table/settings/ListTitleSettings";
import Table from "@/components/table/Table";
import ContractRow from "@/features/vendor-due-diligence-contracts/components/ContractRow";
import { contractsFields } from "@/features/vendor-due-diligence-contracts/constants";

import Typography from "../../../components/Elements/Typography";
import { useSortable } from "../utils/useSortable";

export default function VendorAllContracts() {
  const { sortByFieldName, sortDirection, sortParams, setSortBy } =
    useSortable();

  const { workspace_id } = useParams<{ workspace_id: string }>();

  const vendorsContractsList = useWorkspaceContracts(
    Number(workspace_id),
    sortParams,
  );

  // Components
  function RenderHeader({
    title,
    className = "",
  }: {
    title: string;
    className?: string;
  }) {
    return (
      <>
        <Typography
          label={title}
          type="h3"
          size="md"
          weight="semiBold"
          color="generalDark"
          className={classNames({
            [className]: className,
          })}
        />
        <div className="list-title-table">
          <ul>
            <div className="list-column-wrap">
              <div className="list-title-table-wrap">
                {contractsFields.map((field) => (
                  <ListTitleSettings
                    key={field.field_name}
                    title={field.display_name}
                    width={field.width}
                    sortable={field.sortable}
                    sortDirection={
                      field.sortable && sortByFieldName === field.field_name
                        ? sortDirection
                        : undefined
                    }
                    onClick={() =>
                      field.sortable && setSortBy(field.field_name)
                    }
                  />
                ))}
                <span className="stretch-cell" />
              </div>
            </div>
            <div className="vendor-contracts__table-title-indent" />
          </ul>
        </div>
      </>
    );
  }

  return (
    <Table>
      <LoadingWrapper
        loading={!vendorsContractsList.data && vendorsContractsList.isLoading}
        errorText={
          vendorsContractsList.error &&
          "Failed to load contracts. Please refresh to try again."
        }
        loadingLayout="table"
      >
        <div className="vendor-contracts table-list-wrap">
          <RenderHeader title="Active Contracts" className="tw-pt-3" />
          {vendorsContractsList.data?.active_contracts?.map((contract) => {
            return <ContractRow key={contract.id} contract={contract} />;
          })}
          <RenderHeader title="Inactive Contracts" className="tw-pt-8" />
          {vendorsContractsList.data?.inactive_contracts?.map((contract) => {
            return <ContractRow key={contract.id} contract={contract} />;
          })}
        </div>
      </LoadingWrapper>
    </Table>
  );
}
